import { ShareType } from 'app/components/Shares/types';
import { AudioPlayerAudioInstance } from 'app/store/AudioPlayer/slice.types';
import { Center } from '@chakra-ui/react';

export const CONTROLS_SIZE = 32;
export const OPTIONS_SIZE = 50;

const getColumnSize = (
  percent: number,
  actionsWidth: number,
  totalWidth?: number
) => {
  if (!totalWidth) {
    return undefined;
  }
  return (totalWidth - CONTROLS_SIZE - OPTIONS_SIZE - actionsWidth) * percent;
};

export const getColumns = (
  actionsCount: number,
  totalWidth?: number,
  shareType?: ShareType
) => {
  const actionsWidth = actionsCount * 20 + actionsCount * 24;
  const columnSize = shareType === ShareType.PLAYLIST ? 0.25 : 0.33;
  return [
    {
      accessorKey: 'controls',
      header: <Center w={5}>#</Center>,
      accessory: true,
      size: CONTROLS_SIZE,
      sx: { pl: 1 },
    },
    {
      accessorKey: 'title',
      header: 'Title',
      sx: { pl: 0 },
      enableResizing: true,
      minSize: 40,
      size: getColumnSize(columnSize, actionsWidth, totalWidth),
    },
    ...(shareType === ShareType.PLAYLIST
      ? [
          {
            accessorKey: 'song',
            header: 'Song',
            size: getColumnSize(columnSize, actionsWidth, totalWidth),
            minSize: 52,
            enableResizing: true,
          },
        ]
      : []),
    {
      accessorKey: 'note',
      header: 'Note',
      size: getColumnSize(columnSize, actionsWidth, totalWidth),
      minSize: 52,
      enableResizing: true,
    },
    {
      accessorKey: 'duration',
      header: 'Duration',
      size: getColumnSize(columnSize, actionsWidth, totalWidth),
      minSize: 76,
      enableResizing: true,
    },
    ...(actionsCount > 0
      ? [{ accessorKey: 'actions', size: actionsWidth }]
      : []),
    {
      accessorKey: 'gap',
      size: 0,
    },
    ...(actionsCount > 0
      ? [
          {
            accessorKey: 'options',
            size: OPTIONS_SIZE,
            isOptions: true,
          },
        ]
      : []),
  ];
};

export const getMixPanelprops = (
  playlistAudio: AudioPlayerAudioInstance,
  shareType?: ShareType
) =>
  shareType === ShareType.AUDIO
    ? { songGuid: playlistAudio.songGuid }
    : { playlistGuid: playlistAudio.playlistGuid };
